const getRpcUrl = () => {
    return 'https://gateway.pinata.cloud/ipfs/';
}

export default getRpcUrl
